import { createContext } from 'react';

import type { AuthContextType, CompanyLinkDefaultType } from './auth.types';

const initialValue = {
  loading: true,
  user: null,
  company: null,
  visibilityGroup: null,
  signOut: () => null,
  updateUser: () => null,
  fetchUser: () => null,
  companyLinkDefault: 'profile' as CompanyLinkDefaultType,
  homeRoute: '/dashboard',
  showCardInfo: true,
  isReportsEnabled: false,
  isTagVisible: false,
  isCurator: false,
  isAdmin: false,
  isHatchAdmin: false,
  isStaff: false,
  isDigestAvailable: false,
  isImpersonating: false,
  revertImpersonatingUser: () => null,
  isDashboardNewsEnabled: false,
  isCardFeedbackDisabled: true,
  isCardSentimentEnabled: false,
  isCardSentimentAndFeedbackOnHoverDisabled: false,
  isChatExportEnabled: false,
  isWinLossEnabled: false,
  isWinLossExclusive: false,
  // true, unlike the feature flags around it: this means "not restricted by an allowlist",
  // and the unconfigured state is unrestricted. It also matches what the provider computes
  // for a null company, so components rendered without one (stories, some tests) behave as
  // they did before the allowlist existed rather than silently losing the nav item.
  isWinLossVisibleToVisibilityGroup: true,
  isHatchExclusive: false,
  isCompetitiveAnalyticsOverviewReportEnabled: false,
  isCompetitiveAnalyticsThreatAnalysisReportEnabled: false,
  isCompetitiveAnalyticsRepPerformanceReportEnabled: false,
  isCompetitiveAnalyticsDataHygieneReportEnabled: false,
  isCompetitiveAnalyticsImpactReportEnabled: false,
  isCompetitiveAnalyticsProgramImpactReportEnabled: false,
  isConsumerReportEnabledForCurators: false,
  isCuratorReportEnabledForCurators: false,
  isCRAReportEnabledForCurators: false,
  isAskKlueExportEnabledForCurators: false,
  isAskKlueExportEnabled: false,
  isCompetitiveDashboardEnabledForConsumers: false,
  isAskKlueEnabled: false,
  isDashboardAskKlueEnabled: true,
  isBattlecardAskKlueEnabled: false,
  isDashboardAskKluePreviewForCuratorsEnabled: false,
  isDashboardNewsToggleDefaultOff: false,
  isCompanyLandingPageEnabled: false,
  isCompanyFavoritesEnabled: false,
  isUpdateSummaryEnabled: false,
  isSFDCDataSyncUserRoleEnabled: false,
  isFeedHiddenInConsumerNavEnabled: false,
  isInsightsWhyWeWinLoseEnabled: false,
  isCallInsightsDemoReplacementEnabled: false,
  isNewCardEditorEnabled: false,
  isContentEditorV3Enabled: false,
  isCreateAIBattlecardEnabled: false,
  isEditorTemplateBlocksEnabled: false,
  isGenAISearchResultsEnabled: false,
  isSFDSProductMappingEnabled: false,
  isHSDSProductMappingEnabled: false,
  isSFDSWriteBackEnabled: false,
  isHSDSWriteBackEnabled: false,
  isHSDSMeetingsSyncEnabled: false,
  isAskKlueWizardEnabled: false,
  isConsumerAskKlueToggleHidden: false,
  isKnowledgeHubEnabled: false,
  isCompetitiveDashboardVisible: true,
  isUnifiedSearchEnabled: false,
  isAskKlueDashboardPageEnabled: false,
  isPromptLibraryEnabled: false,
  isSFDSOpportunityEmailSyncEnabled: false,
  isCallInsightsDisabled: false,
  isDealTipsEnabled: false,
  isCopyToBoardsEnabled: false,
};

const authContext = createContext<AuthContextType>(initialValue);

export default authContext;
